<template>
    <!-- 整改详情 -->
    <div>
        <!-- 申请事项 -->
        <div class="details" v-if="info.applyStageName">
            <header class="title">
                <span class="pole"></span>
                <span class="str">
                    申请事项
                    <span class="apply-stage">{{ info.applyStageName }}</span>
                </span>
            </header>
        </div>
        <!-- 审计意见/建议 -->
        <div class="details" id="problemAdvise">
            <header class="title">
                <span class="pole"></span>
                <span class="str">审计意见/建议</span>
            </header>
            <ul class="content">
                <li class="sug" v-for="(item,index) in info.problemAdviseList" :key="index">
                    <span>{{ item.adviseType == 1 ? "建议" : item.adviseType == 2 ? "意见" : "解决方案"}}：
                        {{ getAdviseContent(index) }}
                        <span style="color: #999;" v-if="item.adviseContent.length > 60" @click="expandHideListEvent(index,'problemAdviseList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                    </span>
                </li>
                <li class="sug" v-if="formShow && info.problemAdviseList.findIndex(item => item.adviseType == 1) > -1">
                    <el-form :model="form" :rules="rules" ref="form" style="margin-top: 5px;" >
                        <el-form-item label="是否采纳" prop="adopt">
                            <el-select v-model="form.adopt" placeholder="请选择是否采纳" size="mini">
                                <el-option v-for="item in options" :label="item.label" :value="item.value" :key="item.value"></el-option>
                            </el-select>

                        </el-form-item>
                    </el-form>
                </li>
            </ul>        </div>
        <!-- 整改信息 -->
        <div class="details" v-for="(item,index) in visible.problemZgList" :key="index">
            <header class="title">
                <span class="pole"></span>
                <span class="str">
                    整改详情
                    <span v-if="info.problemZgList.length > 1" style="text-align: left;">{{ index + 1 }}</span>
                </span>
            </header>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">整改措施</li>
                <li style="text-indent: 12px;">
                    {{ getZgContent(index) }}
                    <span style="color: #999;" v-if="item.zgContent.length > 60" @click="expandHideListEvent(index,'problemZgList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <!-- <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">整改措施</van-col>
                <van-col span="16" class="lr">{{ item.zgContent }}</van-col>
                
            </van-row> -->
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">措施类别</van-col>
                <van-col span="16" class="lr">{{ item.measuresName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">整改责任人</van-col>
                <van-col span="16" class="lr">{{ item.zgPersonName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">整改责任主管</van-col>
                <van-col span="16" class="lr">{{ item.zgLeaderName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">整改部门</van-col>
                <van-col span="16" class="lr">{{ item.zgOrgGuidName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">计划完成时间</van-col>
                <van-col span="16" class="lr">{{ item.zgPlanEndTime }}</van-col>
            </van-row>

            <div v-if="show">
                <van-row type="flex" justify="space-between" class="content">
                    <van-col span="8" class="caption">是否完成</van-col>
                    <van-col span="16" class="lr">{{ item.zgStatusName }}</van-col>
                </van-row>
                <ul class="content">
                    <li class="caption" style="margin-bottom: 7px;">实际整改情况</li>
                    <li style="text-indent: 12px;">
                        {{ getSituation(index) }}
                        <span style="color: #999;" v-if="item.zgSituation.length > 60" @click="expandHideSitutaListEvent(index,'problemZgList')">{{ item.situat ? " 收起" : "...展开" }}</span>
                    </li>
                </ul>
            </div>
            
        </div>
    </div>
    
</template>
<script>
import temp from '../../app/temp.vue';
export default {
  components: { temp },
    props: {
        info: {
            type: Object,
            require: true
        },
        show: {
            type: Boolean,
            default: true
        },
        formShow:{
            type: Boolean,
            default: false
        },
        isTrackerSave: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        info: {
            deep: true,
            immediate: true,
            handler(){
                console.log(this.info.problemAdviseList.find(item => item.adviseType == 1));
                if(this.info.problemAdviseList.find(item => item.adviseType == 1)){
                    this.form.adopt = this.info.problemAdviseList.find(item => item.adviseType == 1).adopt;
                }
            }
        },
        "info.problemAdviseList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemAdviseList = this.info.problemAdviseList.map(item => {
                    return {...item,visible: false}
                })
            }  
        },
        "info.problemZgList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemZgList = this.info.problemZgList.map(item => {
                    return {...item,visible: false,situat: false}
                })
            }   
        },
    },
    data(){
        return {
            guid: "",
            form:{
                adopt: "",      //是否采纳
            },
            options: [
                {
                    label: "采纳有价值",
                    value: "0"
                },
                {
                    label: "采纳无价值",
                    value: "2"
                },
                {
                    label: "未采纳",
                    value: "1"
                }
            ],
            rules: {
                adopt: [
                    {required: true,message: "请选择是否采纳",tigger: "change"}
                ]
            },
            visible: {
                problemAdviseList: [],
                problemZgList: []
            }
        }
    },
    methods: {
		getAdviseContent(index){
            return this.visible.problemAdviseList[index].visible ? this.visible.problemAdviseList[index].adviseContent : this.visible.problemAdviseList[index].adviseContent.slice(0,60);
        },
        getZgContent(index){
            return this.visible.problemZgList[index].visible ? this.visible.problemZgList[index].zgContent : this.visible.problemZgList[index].zgContent.slice(0,60);
        },
        getSituation(index){
            return this.visible.problemZgList[index].situat ? this.visible.problemZgList[index].zgSituation : this.visible.problemZgList[index].zgSituation.slice(0,60);
        },
        expandHideListEvent(index,name){
            let info = this.visible[name].find((item,i) => i == index);
            info.visible = !info.visible;
            this.$set(this.visible[name],index,info);
        },
        expandHideSitutaListEvent(index,name){
            let info = this.visible[name].find((item,i) => i == index);
            info.situat = !info.situat;
            this.$set(this.visible[name],index,info);
        },
        // type 1 追踪人是否采纳必填
        submitAdopt(success,fail){
            this.$refs["form"].validate(valid => {
                if(valid){
                    let params = {
                        guid: this.info.problemAdviseList.find(item => item.adviseType == 1).guid,
                        adopt: this.form.adopt
                    }
                    success(params)
                    // this.$emit("submitSuccess",params);
                } else {
                    console.log("有问题");
                    // this.$emit("submitFail");
                    fail('problemAdvise')
                    return false;
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
    //板块radius
    @borderRadius: 4px;
    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;
    //主标题颜色
    @titleColor: #0ea6e0;
    //主标题字号
    @titleSize: 16px;
    //中等字号
    @middleSize: 14px;

    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
                .apply-stage{
                    float: right;
                    margin-right: 10px;
                    font-weight: unset;
                }
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
            .lr{
                text-align: right;
                position: relative;
            }
            .sug{
                text-indent: 12px;
                color: #000;
                /deep/ .el-form{
                    padding: 0;
                    .el-form-item__label{
                        font-size: 12px;
                        line-height: 30px;
                        color: #000;
                    }
                    .el-form-item__content{
                        font-size: 12px;
                        line-height: 30px;
                    }
                    .el-input--mini{
                        margin-left: -10px;
                    }
                }
            }
            .overstep{
                overflow:hidden;
                display:-webkit-box;
                -webkit-line-clamp:3;
                -webkit-box-orient:vertical;
                text-overflow:ellipsis;
                white-space:pre-wrap;
                word-wrap:break-word;
            }
        }
        .content:last-child{
            border: unset;
        }
    }
    
</style>